export default "__VITE_ASSET__Z7jk7WuE__"